// Single entry point for all localStorage access so callers never touch the global API directly.

export const getLocalStorageItem = (key) => localStorage.getItem(key);

export const setLocalStorageItem = (key, value) => {
   localStorage.setItem(key, value);
};

export const removeLocalStorageItem = (key) => {
   localStorage.removeItem(key);
};

// JSON helpers: parse on read with a string fallback for values written outside this util
export const getLocalStorageJson = (key) => {
   const raw = getLocalStorageItem(key);
   if (raw === null) return null;
   try {
      return JSON.parse(raw);
   } catch {
      return raw;
   }
};

export const setLocalStorageJson = (key, value) => {
   setLocalStorageItem(key, JSON.stringify(value));
};

export const clearLocalStorage = () => {
   localStorage.clear();
};

export const getAllLocalStorageKeys = () => {
   const keys = [];
   for (let i = 0; i < localStorage.length; i += 1) {
      const key = localStorage.key(i);
      if (key !== null) keys.push(key);
   }
   return keys;
};

export const removeLocalStorageItems = (keys) => {
   keys.forEach((key) => removeLocalStorageItem(key));
};
